export default {
  personalInformation: '我的个人信息',
  aboutProgram: '关于推荐计划',
  jobAlert: '职位提醒',
  jobList: '职位列表',
  changeEmail: '更改邮箱',
  bindEmail: '绑定邮箱',
  changeMobile: '更改手机',
  bindMobile: '绑定手机',
  changePassword: '修改密码',
  privacySetting: '隐私设置',
  finishProfile: '完成档案',
  myApplication: '我的申请',
  myProfile: '我的档案',
  myReport: '我的报告',
  myPersonalDashboard: '个人信息',
  completedApplication: '已完成的申请',
  incompleteApplication: '未完成的申请',
  policy: '我的授权',
  myReferralAndRewards: '我的推荐和奖励',
  assessment: '评估',
  applicationHistory: '职位申请历史',
  leads: '推荐',
  dashboard: '统计',
  rewards: '奖励',
  referralProgram: '关于推荐计划',
  leaded: '我的推荐',
  applied: '申请',
  hidden: '已隐藏',
  leaderBoard: '推荐排行榜',
  group: {
    referrals: '推荐',
    functions: '功能',
    operationCenter: '操作中心',
    dashboard: '操作中心'
  },
  tooltip: {
    finishProfile: '请完成档案',
    processApplication: '{count}个待处理的申请',
    jobAlert: '职位提醒',
    logout: '退出'
  },
  logout: '退出',
  mobile: {
    careerSite: '招聘主页',
    jobsList: '职位列表',
    allJobs: '所有职位',
    companyJobsList: '{company} 职位',
    myReferrals: '我的推荐',
    leads: '推荐',
    dashboard: '统计',
    rewards: '奖励',
    leaderBoard: '排行榜',
    referralProgram: '关于推荐计划',
    accountManagement: '帐号管理'
  }
}
